import {
  APPROVED_CEMETERIES,
  APPROVED_CITY_NAMES,
  GRAVE_MAP_CEMETERIES,
} from './approvedCemeteryCatalog';

export function normalizeCatalogName(value = '') {
  return String(value).trim().toLocaleLowerCase('az-AZ')
    .replaceAll('ə', 'e')
    .replaceAll('ı', 'i')
    .replaceAll('ş', 's')
    .replaceAll('ç', 'c')
    .replaceAll('ö', 'o')
    .replaceAll('ü', 'u')
    .replaceAll('ğ', 'g')
    .replace(/[^a-z0-9]+/g, '');
}

export function stableCityId(name) {
  return `city_${normalizeCatalogName(name)}`;
}

export function stableCemeteryId(cityName, cemeteryName) {
  return `cemetery_${normalizeCatalogName(cityName)}_${normalizeCatalogName(cemeteryName)}`;
}

export function mergeApprovedCities(records) {
  const byName = new Map(records.map(city => [normalizeCatalogName(city.name), city]));
  const approved = APPROVED_CITY_NAMES.map(name => byName.get(normalizeCatalogName(name)) || {
    id: stableCityId(name), name, isActive: true, approvedFallback: true,
  });
  const approvedKeys = new Set(APPROVED_CITY_NAMES.map(normalizeCatalogName));
  return [...approved, ...records.filter(city => !approvedKeys.has(normalizeCatalogName(city.name)))]
    .sort((a, b) => a.name.localeCompare(b.name, 'az'));
}

export function mergeApprovedCemeteries(records, cities) {
  const cityNameById = new Map(cities.map(city => [city.id, city.name]));
  const existingKey = cemetery => `${normalizeCatalogName(cityNameById.get(cemetery.cityId) || cemetery.cityName)}|${normalizeCatalogName(cemetery.name)}`;
  const byKey = new Map(records.map(cemetery => [existingKey(cemetery), cemetery]));
  const fallbacks = [];
  for (const [cityName, names] of Object.entries(APPROVED_CEMETERIES)) {
    const city = cities.find(item => normalizeCatalogName(item.name) === normalizeCatalogName(cityName));
    for (const name of names) {
      const key = `${normalizeCatalogName(cityName)}|${normalizeCatalogName(name)}`;
      if (!byKey.has(key)) {
        fallbacks.push({
          id: stableCemeteryId(cityName, name), name, cityId: city?.id || stableCityId(cityName),
          cityName, isActive: true, approvedFallback: true,
          specialCategory: name === 'Fəxri Xiyaban' || name === '2-ci Fəxri Xiyaban' || name.includes('Şəhidlər Xiyabanı'),
          requiresManualConfirmation: name === 'Fəxri Xiyaban' || name === '2-ci Fəxri Xiyaban' || name.includes('Şəhidlər Xiyabanı'),
          graveMapAvailable: GRAVE_MAP_CEMETERIES.has(`${cityName}|${name}`),
        });
      }
    }
  }
  return [...records, ...fallbacks];
}

export function canDeleteCity(city, cemeteries) {
  return !cemeteries.some(cemetery => cemetery.cityId === city.id && !cemetery.deletedAt);
}

export function parseOptionalCoordinate(value) {
  if (value === '' || value === null || value === undefined) return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}

export function cemeteriesForSelectedCity(cemeteries, cityId, search = '') {
  if (!cityId) return [];
  const query = normalizeCatalogName(search);
  return cemeteries.filter(cemetery =>
    cemetery.cityId === cityId &&
    normalizeCatalogName(cemetery.name).includes(query));
}

export function preferredInitialCityId(cities) {
  return cities.find(city => city.name === 'Bakı')?.id || cities[0]?.id || '';
}

export function newCemeteryDraft(cityId) {
  return { cityId };
}
